export default "__VITE_ASSET__BXPLzEU3__"